export default __webpack_public_path__ + "static/hochzeitsfotos-berlin-brandenburg-luxemburg-claudia_nuernberger-3aecf7931ac8ccf631147fa13b246df8.jpg";